<template>
    <SOSlotModal :modal-title="pageSetting.modal.title" :modal-id="pageSetting.modal.id" @close="close">
        <template v-slot:modal-body>
            <div class="f-regular f-16 f-c-black m-d-12 m-t-16">
                Anda akan mengirim Blast WA:
                <ul>
                    <li>Menggunakan {{ getCountPesan }} perangkat</li>
                    <li>{{ getCountTemplate }} template pesan</li>
                    <li>ke {{ totalCustomer }} konsumen</li>
                </ul>
            </div>
            <div class="bg-grey p-x-12 p-y-12 m-d-12">
                <div class="f-regular f-14 f-c-black">
                    <b>Estimasi pengiriman:</b> sekitar {{ getEstimasiPengiriman }}
                </div>
                <div class="f-regular f-14 f-c-black">
                    <b>Estimasi biaya:</b> {{ totalCustomer }} kuota pesan (dipotong dari perangkat yang digunakan)
                </div>
            </div>

            <div class="f-regular f-14 f-c-midgrey">
                Jika kuota telah habis, maka dikenakan 100 M-coin per pesan yang terkirim.
            </div>
        </template>
        <template v-slot:modal-footer>
            <SOButton
                class="m-0 p-d-12"
                :text="'Kirim Blast WA'"
                :primary="true"
                :full="true"
                :disable="isFetching"
                :loading="isFetching"
                @action="doCreateBlast"
            />
            <SOButton
                class="m-0"
                :text="'Batal'"
                :outline="true"
                :full="true"
                :disable="isFetching"
                :loading="isFetching"
                @action="close"
            />
        </template>
    </SOSlotModal>
</template>

<script>
import { moduleName } from "./../../store/state";
import { mapActions, mapGetters } from "vuex";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";
import resulter from "@/store/utils/resulter";

export default {
    name: "ModalHentikanBlast",
    components: {
        SOSlotModal,
        SOButton,
    },
    computed: {
        ...mapGetters(moduleName, {
            payload: "payloadCreateBlast",
            totalCustomer: "totalCustomer",
            isFetching: "isFetching",
        }),
        getCountPesan() {
            return this.payload.iddevice.length;
        },
        getCountTemplate() {
            return this.payload.idtemplate.length;
        },
        getBiayaMCoin() {
            return this.formatRupiah((this.totalCustomer * 100).toString());
        },
        getEstimasiPengiriman() {
            var x, y, jam, menit, detik, jamStr, menitStr, detikStr;
            x = this.totalCustomer * this.payload.interval;
            y = x % 3600;
            jam = x / 3600;
            menit = y / 60;
            detik = y % 60;

            jamStr = Math.floor(jam) > 0 ? Math.floor(jam).toString() + " jam " : "";
            menitStr = Math.floor(menit) > 0 ? Math.floor(menit).toString() + " menit " : "";
            detikStr = Math.floor(detik) > 0 ? Math.floor(detik).toString() + " detik " : "";
            return jamStr + menitStr + detikStr;
        },
    },
    data() {
        return {
            customerTemp: {},
            pageSetting: {
                modal: {
                    title: "Konfirmasi",
                    id: "modal-jeda-wa-blast",
                },
            },
        };
    },
    mounted() {
        $("#" + this.pageSetting.modal.id).modal("show");
    },
    methods: {
        ...mapActions({
            createBlast: `${moduleName}/createBlast`,
            resetListHistory: `${moduleName}/resetListHistory`,
            setResponse: `${moduleName}/setResponse`,
            setFetching: `${moduleName}/setFetching`,
            resetPayload: `${moduleName}/resetPayloadCreateBlast`,
        }),
        doCreateBlast() {
            this.smartTrackingClick('konfirmasi_kirim_blast_whatsapp')

            this.createBlast(this.payload)
                .then((response) => {
                    if (!response.data) {
                        this.$toast.error(response);
                    } else {
                        let { code, status, msg, data } = response.data;

                        if (status && code === 200) {
                            this.$toast.success(msg);
                            this.resetListHistory();
                            this.resetPayload();
                            this.$router.push({ name: "wa_blast.list" });
                        } else {
                            this.setResponse(resulter.errorResult(msg));
                            this.$toast.error(msg);
                        }
                    }
                    this.setFetching(false);
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                    this.setResponse(resulter.errorResult(e));
                });
        },

        close() {
            this.$router.back();
            this.smartTrackingClick('batal_kirim_blast_whatsapp')
        },
    },
};
</script>
